import { BaseVm } from '@/mobxTools'
import { observable } from 'mobx'
import type { EmptyBoxProps } from './EmptyBox'

export class EmptyBoxVm extends BaseVm<EmptyBoxProps> {
  /** props 不应该被修饰为 state */
  props!: EmptyBoxProps

  // states
  @observable open = false

  public onViewCreate(): void {
    // view 被创建完成后执行
  }

  public onViewDestroy(): void {
    // view 被销毁后执行
  }
}
